<template>
  <div
    class="publicheader"
    v-if="webtitle"
    :class="{ dark: headerInfo.fontBlack }"
    :style="{ color: headerInfo.color, background: headerInfo.bg }"
  >
    {{ headerInfo.title }}
    <div class="icon_back" @click="goBack"></div>
    <div v-if="headerInfo.share" class="headerShare" @click="handleShare">
      <img src="https://images.zhibo.tv/2020/0126/icon_share@2x.png" alt="" />
    </div>
    <div class="rightKey" @click="openJifen">
      {{ headerInfo.rightKey }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['headerInfo'],
  name: '',
  data() {
    return {
      webtitle: true,
      // length:0,
      routeName: '',
      seriesId: ''
    }
  },
  computed: {},
  watch: {},
  created() {
    this.routeName = this.$route.name
    this.seriesId = this.headerInfo.seriesId ? this.headerInfo.seriesId : ''
  },
  methods: {
    goBack() {
      this.$NATIVE.oldfun.o_closeLayer()
    },
    handleShare() {
      this.$emit('toShare')
    },
    openJifen() {
      this.$emit('openDialog')
    }
  }
}
</script>

<style lang="less" scoped>
.publicheader {
  width: 100vw;
  height: 0.88rem;
  position: relative;
  background: #ffffff;
  font-size: 0.34rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  line-height: 0.88rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 4;
  .icon_back {
    width: 0.2rem;
    height: 0.36rem;
    position: absolute;
    top: 0.25rem;
    left: 0.3rem;
    // background: url('../assets/icon/icon_back_b@2x.png') no-repeat center;
    background: url('https://static-vip.sports.cctv.com/cctv-vip/pc/20210511/icon_back@3x.png')
      no-repeat center;
    background-size: 100%;
  }
  .header_right {
    position: absolute;
    right: 0.3rem;
    top: 0rem;
    font-size: 0.34rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .headerShare {
    width: 0.4rem;
    height: 0.4rem;
    position: absolute;
    right: 0.3rem;
    top: 0.25rem;
    img {
      width: 0.4rem;
      height: 0.4rem;
    }
  }
  .rightKey {
    position: absolute;
    height: 0.88rem;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0.3rem;
    top: 0;
    font-size: 0.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.5);
  }
}
.dark {
  box-shadow: none;
  color: #212121;
  .icon_back {
    background: url('https://images.zhibo.tv/2020/0122/icon_back_b@2x.png')
      no-repeat center;
    background-size: 100%;
  }
}
</style>
